import { Box, Button, Card, CardMedia, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { fetchUsersCount } from "./utils";

 const fetchHostagesPhotos = async () => {
  try {
      const response = await fetch(`/open/hostages/photos`, {
          method: "GET",
          credentials: 'include' // include cookies in the request
      });
      return await response.json();
  } catch (err) {
      console.error('Error fetching hostages photos:', err);
  }
}

const LandingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexLoaded, setCurrentIndexLoaded] = useState(0);
  const [usersCount, setUsersCount] = useState("");
  const [photos, setPhotos] = useState<string[]>([]);
  

  useEffect(() => {
     // Set placeholder image initially
    const placeholderImage = "https://not-alone-backet.s3.us-east-1.amazonaws.com/images/66db418882f0f326e6972ae1/1121152640__lkly2n.jpg"
    setPhotos([placeholderImage]);

    // Fetch photos and update state after a short delay
    const fetchAndSetPhotos = async () => {
      const fetchedPhotos = await fetchHostagesPhotos();
      if (fetchedPhotos && fetchedPhotos.length > 0) {
        setTimeout(() => setPhotos(fetchedPhotos), 1500); // 1.5-second delay
      }
    };

    fetchAndSetPhotos();
  }, []);

  
  const goToNextImage = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
  }, [photos.length]);

  useEffect(() => {
    const interval = setInterval(goToNextImage, 5000);
    return () => clearInterval(interval);
  }, [goToNextImage]);


  useEffect(() => {
    fetchUsersCount().then((res) => {setUsersCount(res.totalUsers)})
  }, [])

  const handleImageLoad = () => {
    setCurrentIndexLoaded(currentIndex);
  };

  return (
    <Box
      sx={{
        position: "relative",
        textAlign: "center",
        maxWidth: "800px",
        height: "auto",
        overflow: 'hidden',
        justifyContent: "center",
        alignItems: "center",
        mx: "auto",
      }}
    >
      {/* Display the current image */}
      <Card sx={{ position: "relative" }}>
        <CardMedia
          component="img"
          image={photos[currentIndex]} 
          alt={"not alone"}
          onLoad={handleImageLoad} // Call the handler when the image is loaded
          sx={{
            width: "100%",
            height: "470px",
            overflow: 'hidden',
            transition: "opacity 0.5s ease", // Smooth transition after image loads
          }}
        ></CardMedia>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "25%",
            background: "linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))", // Black gradient
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white", // Text color
            padding: 2, // Optional padding for content
            objectFit: "cover",
          }}
        ></Box>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            padding: 2,
          }}
        >
          <Typography
            sx={{ marginTop: "34px" }}
            mx={"auto"}
            maxWidth={"200px"}
            align="center"
            fontWeight={700}
            fontSize={"22px"}
            lineHeight={"29.92px"}
          >
          {t('landing.title1')}
          <br />
          {t('landing.title2')}
          </Typography>
        </Box>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            padding: 2,
          }}
        >
          <Button
            variant="contained"
            sx={{
              marginBottom: "18px",
              marginTop: "auto",
              backgroundColor: "#FF395D",
              borderRadius: "8px",
              borderBottom: "1px",
              padding: "14px 32px 14px 32px",
              gap: "8px",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => navigate("/login")}
          >
          {t("welcome.joinUs")}
          </Button>
        </Box>
      </Card>

      <Box
        style={{
          backgroundColor: "#F6F6F6",
          borderBottom: "1px solid #AFAFAF",
          borderTop: "1px solid #AFAFAF",
          paddingTop: "16px",
          paddingBottom: "16px",
          gap: "16px",
        }}
      >
        <Box mx={"auto"} maxWidth={"200px"} gap={"20px"}>
          <Typography
            gap={"8px"}
            color="#000000"
            fontSize={"18px"}
            fontWeight={"600"}
            lineHeight={"16.8px"}
            letterSpacing={"-0.41px"}
            align="center"
          >
            {t("statistics.header")}
          </Typography>
          <Typography
            marginTop={"20px"}
            gap={"10px"}
            color="#FF395D"
            fontSize={"28px"}
            fontWeight={"700"}
            lineHeight={"38.08px"}
            align="center"
          >
            {usersCount}
          </Typography>
          <Typography
            gap={"8px"}
            color="#4D4D4D"
            fontWeight={"400"}
            lineHeight={"16.8px"}
            letterSpacing={"-0.41px"}
            align="center"
          >
            {t("statistics.subtitle")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default LandingPage;
